export enum InternalClassName {
  BrandLogoImg = '_brand-logo-img_24bb', // 需要更新 prepareDocsConfigScript.js
  MainScrollContainer = '_main-scroll-container_5d6f',
  ResponseTitle = '_response-title_974e',
  TreeScrollContainer = '_tree-scroll-container_5b4e',
}
